// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3nuPe","col":"styles_col__33DRy","fulfillmentStatus":"styles_fulfillmentStatus__1BgTV","emailCol":"styles_emailCol__3SuGU"};